import { useState } from "react";
import UIWrapper from "../../../components/UIWrapper";
import { Divider, Tab, Tabs } from "../../../mui";
import AF2Active from "./AF2Active";
import AF2History from "./AF2History";
import LVAF2Active from "./LVAF2Active";
import LVAF2History from "./LVAF2History";

const LVDataUpdation = () => {
  const [value, setValue] = useState("one");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <UIWrapper title="LV Data Updation" paper>
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        aria-label="LV AF2 Data Updation"
      >
        <Tab value="one" label="LV Active AF2" />
        <Tab value="two" label="LV AF2 History" />
      </Tabs>
      <Divider style={{ width: "100%" }}></Divider>
      {value === "one" && <LVAF2Active />}
      {value === "two" && <LVAF2History />}
    </UIWrapper>
  );
};

export default LVDataUpdation;
